const dateTimeFormat = new Intl.DateTimeFormat("fi", {
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "Etc/GMT-2", // The source data does not take DST into account
});

export const format = (date) => {
  const [
    { value: day },
    ,
    { value: month },
    ,
    { value: hour },
    ,
    { value: minute },
  ] = dateTimeFormat.formatToParts(date);
  return { day, month, hour, minute };
};
